<template>
  <div class="bg-white shadow-lg rounded-lg overflow-hidden">
    <div class="bg-primary text-white p-4">
      <h3 class="text-xl font-semibold">User Group Management</h3>
    </div>
    <div class="p-6 space-y-4">
      <div class="grid grid-cols-2 gap-4">
        <div v-for="(stat, index) in userStats" :key="index" class="bg-gray-100 p-4 rounded-lg">
          <h4 class="text-lg font-semibold text-primary">{{ stat.label }}</h4>
          <p class="text-3xl font-bold text-primary-light">{{ stat.value }}</p>
        </div>
      </div>
      <button @click="manageUsers" class="w-full bg-primary text-white px-4 py-2 rounded-md hover:bg-purple-900 transition duration-300">
        Manage Users
      </button>
      <div v-if="userRole == 'admin'" class="mt-12">
        <h4 class="text-lg font-semibold text-primary mb-2">Top 5 User Groups</h4>
        <ul class="space-y-2">
          <li v-for="group in topGroups" :key="group.id" class="flex justify-between items-center bg-gray-50 p-2 rounded">
            <span>{{ group.name }}</span>
            <span class="font-semibold text-primary-light">{{ group.members.length }} members</span>
          </li>
        </ul>
      </div>
      <button v-if="userRole == 'admin'" @click="manageGroups" class="w-full bg-primary text-white px-4 py-2 rounded-md hover:bg-purple-900 transition duration-300">
        Manage Groups
      </button>
    </div>
  </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex'
  
  export default {
  name: 'UserGroupManagement',
  computed: {
    ...mapState('users', ['admins']),
    ...mapState('groups', ['groups']),
    ...mapState(['staff', 'studentCount']),
    ...mapState({
      userRole: state => state.auth.userRole,
    }),
    userStats() {
      return [
        { label: 'Total Users', value: this.staff.length + this.studentCount },
        { label: 'Admin Users', value: this.admins.length },
        { label: 'Staff Users', value: this.staff.length - this.admins.length },
        { label: 'Students', value: this.studentCount }
      ]
    },
    topGroups() {
      return [...this.groups]
        .sort((a, b) => b.members.length - a.members.length)
        .slice(0, 5);
    }
  },
  methods: {
    ...mapActions('groups', ['fetchGroups']),
    ...mapActions('users', ['fetchAdmins']),
    ...mapActions(['fetchStaff', 'fetchStudentCount']),
    manageUsers() {
      this.$router.push('/user-management')
    },
    manageGroups() {
      this.$router.push('/group-management')
    }
  },
  created() {
    this.fetchGroups()
    this.fetchAdmins()
    this.fetchStaff()
    this.fetchStudentCount()
  }
  }
  </script>
  
  